import { api } from "@/api/api";

export const Solution = {
    state: {
        solutionList: [],
        totalCount: 0,
    },
    getters: {
        getSolutionList(state) {
            return state.solutionList;
        },
        getSolutionTotalCount(state) {
            return state.totalCount;
        },
    },
    mutations: {
        setSolutionList(state, payload) {
            state.solutionList = payload;
        },
        setSolutionTotalCount(state, payload) {
            state.totalCount = payload;
        },
    },
    actions: {
        async getSolutionList({ commit }, param) {
            await api.solution
                .getSolutionList(param)
                .then((res) => {
                    commit("setSolutionList", res.data.solution);
                    commit("setSolutionTotalCount", res.data.total);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getSolution(_, id) {
            const response = await api.solution.getSolution(id).catch((err) => {
                console.log(err);
                return Promise.reject(err.response.data.message);
            });
            return Promise.resolve(response.data);
        },

        async addSolution({ dispatch }, args) {
            await api.solution
                .addSolution(args)
                .then(() => {
                    dispatch("getSolutionList");
                })
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve();
        },

        async updateSolution({ dispatch }, args) {
            await api.solution
                .updateSolution(args)
                .then(() => {
                    dispatch("getSolutionList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteSolution({ dispatch }, args) {
            await api.solution
                .deleteSolution(args)
                .then(() => {
                    dispatch("getSolutionList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },
    },
};
